export function BadgeLuckyHero({ luckyHero }: { luckyHero: boolean }) {
  if (!luckyHero) {
    return null
  }

  return (
    <span
      className="inline-flex h-4 shrink-0 items-center justify-center rounded-full px-1.5 text-[7px] font-bold uppercase tracking-[0.04em] text-neutral-700 align-middle"
      style={{
        background:
          'linear-gradient(135deg, #7a5a00 0%, #c99700 28%, #ffd54a 52%, #fff1a8 72%, #b8860b 100%)',
        border: '1px solid rgba(120, 84, 0, 0.55)',
        boxShadow: '0 2px 8px rgba(255, 191, 0, 0.35)',
        fontFamily: 'Nunito, sans-serif',
        lineHeight: 1,
      }}
    >
      <span style={{ position: 'relative', top: '1px' }}>Lucky Hero</span>
    </span>
  )
}
